//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './TagClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';



export type EditTagQueryParameters = {
  id: number ;
}

export type RemoveTagQueryParameters = {
  id: number ;
}

export function removeUnusedUrl(): string {
  let url_ = getBaseUrl() + "/api/dictionaries/tags/remove-unused";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeUnusedMutationKey(): MutationKey {
  return trimArrayEnd([
      'TagClient',
      'removeUnused',
    ]);
}

export function useRemoveUnusedMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeUnusedMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.removeUnused(),
    mutationKey: key,
  });
}
  
export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/dictionaries/tags";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'TagClient',
      'create',
    ]);
}

export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.DictionaryRecordDto, unknown, Types.CreateTagDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DictionaryRecordDto, unknown, Types.CreateTagDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateTagDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function getUrl(): string {
  let url_ = getBaseUrl() + "/api/dictionaries/tags";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.DictionaryRecordDto[], unknown, Types.DictionaryRecordDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.DictionaryRecordDto[], unknown, Types.DictionaryRecordDto[]>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'TagClient',
      'get',
    ]);
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
axiosConfig    );
}

export function useGetQuery<TSelectData = Types.DictionaryRecordDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.DictionaryRecordDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.DictionaryRecordDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.DictionaryRecordDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.DictionaryRecordDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.DictionaryRecordDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetData(queryClient: QueryClient, updater: (data: Types.DictionaryRecordDto[] | undefined) => Types.DictionaryRecordDto[], ) {
  queryClient.setQueryData(getQueryKey(),
    updater
  );
}

export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.DictionaryRecordDto[] | undefined) => Types.DictionaryRecordDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function editUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/dictionaries/tags/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function editMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'TagClient',
      'edit',
      id as any,
    ]);
}

export function useEditMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.DictionaryRecordDto, unknown, Types.UpdateTagDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DictionaryRecordDto, unknown, Types.UpdateTagDto, TContext> {
  const key = editMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.UpdateTagDto) => Client.edit(id, dto),
    mutationKey: key,
  });
}
  
type Edit__MutationParameters = EditTagQueryParameters & {
  dto: Types.UpdateTagDto;
}

export function useEditMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.DictionaryRecordDto, unknown, Edit__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: EditTagQueryParameters}): UseMutationResult<Types.DictionaryRecordDto, unknown, Edit__MutationParameters, TContext> {
  const key = editMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Edit__MutationParameters) => Client.edit(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function removeUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/dictionaries/tags/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'TagClient',
      'remove',
      id as any,
    ]);
}

export function useRemoveMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.remove(id),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemoveTagQueryParameters

export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveTagQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}